import { render, staticRenderFns } from "./ArsenalProduct.vue?vue&type=template&id=f2f1bbc4&"
import script from "./ArsenalProduct.vue?vue&type=script&lang=js&"
export * from "./ArsenalProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports